import { render } from "./MenuButton.vue?vue&type=template&id=1d3ad1dc&scoped=true"
const script = {}

import "./MenuButton.vue?vue&type=style&index=0&id=1d3ad1dc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3ad1dc"]])

export default __exports__